// extracted by mini-css-extract-plugin
export default {"menuBlock":"GF-z","title":"HF-z","nav":"IF-z","flexCell":"JF-z","facetLink":"KF-z"};